import { Bar } from 'react-chartjs-2';

const LIMIT_NUMBER_OF_GRAPH = 60;
const data = {
  labels: ['Campaña 1', 'Campaña 2', 'Campaña 3', 'Campaña 4', 'Campaña 5', 'Campaña 6'],
  datasets: [
    {
      label: '# de Campañas',
      data: [22, 19, 3, 5, 2, 44, LIMIT_NUMBER_OF_GRAPH],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(155, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(155, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

const optionsGraph = {
  indexAxis: 'y', // Si cambia a x se coloca en Vertical

  elements: {
    bar: {
      borderWidth: 2,
    },
  },

  responsive: true,

  plugins: {
    legend: {
      display: false,
      position: 'right', // legend de la gráfica (Opcional pasar display a true)
    },
    title: {
      display: false,
      text: 'Aqui va el titulo de la gráfica (Opcional pasar display a true)',
    },
  },
};

const SummaryGraph = () => {
  return (
  <>
    <Bar data={data} options={optionsGraph} />
  </>
  )
}

export default SummaryGraph;
